import React, { useState, useEffect, useCallback } from "react";
import { useLocation, Redirect, useHistory } from "react-router-dom";
import { validateToken } from "service/Common";
import { logout } from "utils/helper";
import SessionExpire from "component/SessionExpire";
import Header from "component/Header/index";
import SideBar from "component/SideBar/index";
import { getProfile } from "service/Auth";

export const MainLayout = ({ children }) => {
  const location = useLocation();

  const history = useHistory();

  const [sideMenu, setSideMenu] = useState([
    {
      label: "Dashboard",
      icon: "icon-dashboard",
      to: "/admin/dashboard",
      routeName: "dashboard",
    },
    {
      label: "Inventory",
      icon: "icon-inventory",
      to: "/admin/inventory/list",
      routeName: "inventory",
    },
    {
      label: "Donation",
      icon: "icon-donation",
      to: "/admin/donation/list",
      routeName: "donation",
    },
    {
      label: "Dispute",
      icon: "icon-disputed",
      to: "/admin/dispute/list",
      routeName: "dispute",
    },
    {
      label: "Transaction",
      icon: "icon-transaction",
      to: "/admin/transactions/list",
      routeName: "transactions",
    },
    {
      label: "Payments",
      icon: "icon-disputed",
      to: "/admin/payments/list",
      routeName: "payments",
    },
    // {
    //   label: "Payments History",
    //   icon: "icon-disputed",
    //   to: "/admin/payments/payment-history",
    //   routeName: "payments",
    // },
    {
      label: "Directory",
      icon: "icon-directory",
      to: "/admin/directory/seller",
      routeName: "directory",
    },
    {
      label: "Staffs & Roles",
      icon: "icon-staff-role",
      to: "/admin/staffs&roles?tab=role",
      routeName: "staffs&roles",
    },
  ]);

  let [isOpen, setIsOpen] = useState(false);

  let [sessionExpire, setSessionExpire] = useState(false);

  const getProfileData = useCallback(async () => {
    const { data } = await getProfile();

    const profileData = data?.data;

    let token = localStorage.getItem("token");

    if (token != null && profileData.isAdmin === false) {
      console.log(profileData.accessible, "acceible");

      const accessibleModules = profileData?.accessible?.map(
        (data) => data.module
      );
      let newSideBar = sideMenu.filter((list) => {
        return accessibleModules.includes(list.label);
      });
      console.log(newSideBar, "newSideBar", accessibleModules, sideMenu);
      setSideMenu(newSideBar);
      let index = newSideBar.findIndex((item) => {
        return item.routeName == location.pathname.split("/")[2];
      });
      if (index == -1 && newSideBar[0]?.to) {
        history.push(newSideBar[0].to);
      }
    }
  }, [location.pathname.split("/")[2]]);

  useEffect(() => {
    getProfileData();
  }, [getProfileData]);

  if (localStorage.getItem("token") == null) {
    return <Redirect to="/" />;
  }

  const validateUser = async () => {
    try {
      let response = await validateToken();
      if (response.status == 200) {
        return null;
      }
    } catch (error) {
      if (error.status == 201) {
        setSessionExpire(true);
      }
    }
  };

  const handleSideBar = () => {
    setIsOpen(!isOpen);
  };

  const toggleMenu = () => {
    setIsOpen(false);
  };

  return (
    <>
      <div style={{ overflow: "hidden" }}>
        <Header toggle={handleSideBar} />
        <div id="main-content">
          <div>
            <SideBar isOpen={isOpen} toggle={toggleMenu} options={sideMenu} />
            <div
              style={{
                marginLeft: isOpen ? "200px" : "75px",
                transition: "0.3s",
                padding: "10px 15px",
              }}
            >
              {children}
            </div>
          </div>
        </div>
      </div>
      <SessionExpire isOpen={sessionExpire} toggle={() => logout()} />
    </>
  );
};
